import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoggedIn: false,
  token: null,
  userId: null,
  firstName: null,
  email: null,
  role: null,
  loading: false,
  error: null,
  refreshToken: null,
};

export const authSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.isLoggedIn = true;
      state.token = action.payload.token;
      state.userId = action.payload.userId;
      state.firstName = action.payload.firstName;
      state.email = action.payload.email;
      state.role = action.payload.role;
      state.loading = false;
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.token = null;
      state.userId = null;
      state.firstName = null;
      state.email = null;
      state.role = null;
      state.loading= false;
      state.error= null;
      state.refreshToken= null;
      localStorage.removeItem('token');
      localStorage.removeItem('groupId');
      localStorage.removeItem('companyId');
    },
    updateToken: (state, action) => {
      state.token = action.payload;
      localStorage.setItem("token", action.payload);
    },
  },
});

export const { loginStart, loginSuccess, loginFailure, logout,updateToken } = authSlice.actions;

export default authSlice.reducer;
